"use client";

import React, { useEffect, useState } from "react";
import Link from "next/link";

const Footer = () => {
  const [services, setServices] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  useEffect(() => {
    import("./footer.css");
  }, []);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const apiUrl = (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/api\/?$/, '').replace(/\/$/, '') || '';
        const res = await fetch(`${apiUrl}/api/category/active`);
        if (!res.ok) return;
        
        const data = await res.json();
        if (data.success) {
          const all = data.data;
          const serviceParent = all.find(c => c.name === 'Service');
          if (serviceParent) {
            // Get all grandchildren of 'Service' (the actual service links)
            const subCategories = all.filter(c => c.parentId && c.parentId._id === serviceParent._id);
            const subCategoryIds = subCategories.map(sc => sc._id);
            const actualServices = all.filter(c => c.parentId && subCategoryIds.includes(c.parentId._id));
            setServices(actualServices.slice(0, 6)); // limit to 6 for footer
          }
        }
      } catch (err) {
        // Silently catch network errors if the backend is offline to avoid console noise
      }
    };

    fetchServices();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", message: "" });

    try {
      const apiUrl = (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/api\/?$/, '').replace(/\/$/, '') || "";
      const res = await fetch(`${apiUrl}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      let data = {};
      const contentType = res.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        data = await res.json();
      }

      if (res.ok) {
        setStatus({ type: "success", message: "Your message has been sent successfully!" });
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus({ type: "error", message: data.message || "Something went wrong." });
      }
    } catch (err) {
      setStatus({ type: "error", message: "Network error. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="container" id="contact-form">
        <div className="row">
          <div className="lets-form">
            <div className="col-lg-6 col-md-12">
              <div className="left-section">
                <h2>
                  {`Let's`} <br />
                  <span>Talk!</span>
                </h2>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="form-section">
                {status.message && (
                  <div className={`alert ${status.type === 'success' ? 'alert-success' : 'alert-danger'} mb-3`} 
                       style={{ 
                         background: status.type === 'success' ? 'rgba(25, 135, 84, 0.1)' : 'rgba(220, 53, 69, 0.1)',
                         borderColor: status.type === 'success' ? '#19875444' : '#dc354544',
                         color: status.type === 'success' ? '#75b798' : '#ea868f'
                       }}>
                    {status.message}
                  </div>
                )}
                <form id="contactForm" onSubmit={handleSubmit}>
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Full Name"
                    required
                  />
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="name@gmail.com"
                    required
                  />
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Write your message"
                    required
                  ></textarea>
                  <button className="form-btn" type="submit" disabled={loading}>
                    {loading ? "Sending..." : "Submit"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer-section footer-radius text-white py-5">
        <div className="container">
          <div className="row ">
            <div className="col-lg-6 col-md-12 mb-4">
              <div className="footer-transprnt">
                <div className="contact-info mb-3">
                  <i className="fa-regular fa-envelope"></i>
                  <p>support@codeqlik.com</p>
                </div>
              </div>
              <div className="footer-transprnt">
                <div className="contact-info mb-3">
                  <i className="fas fa-phone me-2"></i>
                  <p className="call-text">
                    <a href="tel:+91-8949687368" rel="nofollow">
                      +91-8949687368
                    </a>
                  </p>
                </div>
              </div>
              <div className="footer-transprnt">
                <div className="contact-info address">
                  <i className="fas fa-map-marker-alt me-2"></i>
                  <p>
                    CodeQlik - IT Solutions, 301, 3rd Floor, 244-245, Dhruv
                    Marg, Tilak Nagar, near Baskin-Robbins, Gurunanakpura, Raja
                    Park, Jaipur, Rajasthan 302004
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-1"></div>
            <div className="col-lg-2 col-md-6 col-6 mb-4">
              <h3 className="mb-3 text-start menu-header">Menu</h3>
              <ul className="list-unstyled text-start">
                <li>
                  <Link href="/">
                    <button className="text-white text-decoration-none">
                      Home
                    </button>
                  </Link>
                </li>
                {/* <li>
                  <Link href="/service">
                    <button className="text-white text-decoration-none">
                      Services
                    </button>
                  </Link>
                </li> */}
                <li>
                  <Link href="/about-us">
                    <button className="text-white text-decoration-none">
                      About Us
                    </button>
                  </Link>
                </li>
                <li>
                  <Link href="/projects">
                    <button className="text-white text-decoration-none">
                      Projects
                    </button>
                  </Link>
                </li>
                <li>
                  <Link href="/blog">
                    <button className="text-white text-decoration-none">
                      Blog
                    </button>
                  </Link>
                </li>
                <li>
                  <Link href="/reviews">
                    <button className="text-white text-decoration-none">
                      Review
                    </button>
                  </Link>
                </li>
                <li>
                  <Link href="/contact">
                    <button className="text-white text-decoration-none">
                      Contact
                    </button>
                  </Link>
                </li>
                <li>
                  <Link href="/events">
                    <button className="text-white text-decoration-none">
                      Events
                    </button>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-md-6 col-6 mb-4">
              <h3 className="mb-3 text-start menu-header">Services</h3>
              <ul className="list-unstyled text-start">
                {services.length > 0 ? (
                  services.map((service, idx) => (
                    <li key={idx}>
                      <Link href={`/services/${service.slug}`}>
                        <button className="text-white text-decoration-none">
                          {service.name}
                        </button>
                      </Link>
                    </li>
                  ))
                ) : (
                  <>
                    <li>
                      <Link href="/services/website-development">
                        <button className="text-white text-decoration-none">
                          Website Development
                        </button>
                      </Link>
                    </li>
                    <li>
                      <Link href="/services/mobile-app-development">
                        <button className="text-white text-decoration-none">
                          Mobile Application Development
                        </button>
                      </Link>
                    </li>
                    <li>
                      <Link href="/services/search-engine-optimization">
                        <button className="text-white text-decoration-none">
                          Digital Marketing Solutions
                        </button>
                      </Link>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </footer>

      <footer className="footer-radius">
        <div className="row mt-4 text-center">
          <div className="footer-social-text">
            <h3 className="footer-follow-heading">Follow us:</h3>
            <div className="social-icons d-flex justify-content-center gap-3">
              <a href="#" className="text-white" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://x.com/Rashidrash_1" className="text-white" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <i className="fab fa-x-twitter"></i>
              </a>
              <a href="https://in.linkedin.com/company/codeqlik" className="text-white" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://www.instagram.com/codeqlik/" className="text-white" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://youtube.com/@codeqlik?si=dv6QjYWAoocopL_y" className="text-white" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
      </footer>
      <hr />
      <footer>
        <p>&copy; 2026 CodeQlik. All rights reserved.</p>
      </footer>
    </>
  );
};

export default Footer;
